<script setup lang="ts">
    import {computed, onMounted, watch} from 'vue'
    import {useStorage} from '@vueuse/core'
    import {SelectFieldSingle} from '@/js/components/Common'

    const props = withDefaults(
        defineProps<{
        }>(),
        {
        }
    )

    const years = computed(() =>
    [
        // {title: '2 Jahre', value: '4'},
        {title: '3 Jahre', value: '6'},
        {title: '4 Jahre', value: '8'},
        {title: '8 Jahre', value: '16'},
    ])

    const emit = defineEmits([
        'yearSelected',
    ])

    const yearSelectOptions = computed(() => years.value)

    const selectedYear = computed(() => {
        if (year.value) {
            return year.value
        }

        return 6
    })

    const year = useStorage('lernleitstand-year-select-on-dashboard', () =>
        '6'
    )

    watch(
        () => selectedYear.value,
        () => {
            emit('yearSelected', selectedYear.value)
        }
    )

    onMounted(async () => {
        emit('yearSelected', selectedYear.value)
    })
</script>

<template>
    <div class="d-flex align-center">
        <select-field-single
            v-model="year"
            :items="yearSelectOptions"
            label="Anzeigezeitraum"
            placeholder="Anzeigezeitraum wählen"
            data-test="select-year"
            min-width="300px"
            class="ml-5"
        />
    </div>
</template>

<script></script>

<style scoped></style>
